import type { CSSProperties } from "react"

/**
 * Slime oozing from under the header: an edge flowing left to right, and drips that stretch slowly
 * and let a droplet go now and then.
 * Hidden unless a seasonal theme shows it (globals.css, Halloween's cobwebs-and-drips effect).
 * Transform and opacity only, so it runs on the compositor; decoration, never in the way.
 */

// x (% across), width and length (px), stretch, seconds per ooze, delay, drops a droplet,
// shown on phones too.
const DRIPS = [
  [3, 5, 12, 1.6, 7.5, -1.2, false, true],
  [9, 7, 18, 2.1, 9, -4.1, true, false],
  [16, 4, 10, 1.4, 6, -2.6, false, true],
  [23, 6, 16, 2.3, 10.5, -7.3, true, true],
  [31, 4, 11, 1.5, 6.8, -0.4, false, false],
  [38, 8, 21, 1.9, 11, -5.5, true, true],
  [46, 5, 13, 1.7, 7.2, -3.3, false, false],
  [54, 6, 17, 2.4, 9.6, -8.4, true, true],
  [61, 4, 10, 1.3, 5.8, -1.9, false, false],
  [68, 7, 19, 2, 10, -6.2, true, true],
  [76, 5, 12, 1.6, 7, -2.2, false, false],
  [83, 6, 15, 2.2, 8.8, -4.8, true, true],
  [90, 4, 11, 1.5, 6.4, -0.9, false, false],
  [96, 6, 16, 1.8, 9.2, -3.7, true, true],
] as const

export function HeaderDrips() {
  return (
    <div aria-hidden className="header-drips">
      <span className="drip-edge" />
      {DRIPS.map(([x, w, h, k, t, d, drop, phone], i) => (
        <span
          key={i}
          className={phone ? "drip" : "drip max-sm:hidden"}
          style={
            {
              left: `${x}%`,
              "--w": `${w}px`,
              "--h": `${h}px`,
              "--k": k,
              "--t": `${t}s`,
              "--d": `${d}s`,
            } as CSSProperties
          }
        >
          <span className="drip-stem" />
          <span className="drip-bulb" />
          {drop ? <span className="drip-drop" /> : null}
        </span>
      ))}
    </div>
  )
}
